import { QueryClient } from '@tanstack/react-query';

// Allows to easily create a query client with the right options
export const createQueryClient = () =>
  new QueryClient({
    defaultOptions: {
      queries: {
        refetchOnWindowFocus: false,
        retry: 2,
      },
    },
  });
